import React from 'react';

import { getTranslation } from 'common/react/utils/translations';

export const FixtureMidweekFooty = () => {
    return (
        <div className={`fixtures__badge fixtures__badge--mid-week-footy`}>
            <p className="fixtures__badge-text">
                {getTranslation('label.mid_week_footy')}
            </p>
        </div>
    );
};
